export default __webpack_public_path__ + "static/AvenirLTStd-Heavy-bf2f057cff2c29199cf447ad79fa70be.woff2";